import * as classnames from 'classnames'
import * as React from 'react'
import { compose, pure } from 'recompose'

import Counter, { BackgroundColorType } from '../../molecules/Counter/Counter'
import QuestionTitle from '../../molecules/QuestionTitle/QuestionTitle'
import QuestionChoiceSet from '../QuestionChoiceSet/QuestionChoiceSet'

import * as styles from './Question.css'

interface QuestionProps {
  isHidden?: boolean
  time?: number
  isTimeup?: boolean
  answerCount?: any
  showAnswer?: boolean
  question: any
  index: number
}

const Question: React.FunctionComponent<QuestionProps> = ({
  index,
  question,
  time,
  answerCount,
  isTimeup = false,
  isHidden = false,
  showAnswer = false
}) => {
  if (!question) {
    return <div />
  }
  const timeLimit = time == null ? question.limit_time : Math.ceil(time)
  const choiceSetClass = isHidden ? classnames(styles.hidden, styles.choiceset) : styles.choiceset

  return (
    <div className={styles.container}>
      <div className={styles.questionTitle}>
        <QuestionTitle title={question.title} index={index} />
      </div>
      <div className={styles.main}>
        <div className={choiceSetClass}>
          <QuestionChoiceSet question={question} answerCount={answerCount} showAnswer={showAnswer} />
        </div>
        <div className={styles.counters}>
          <div className={styles.counter}>
            <Counter
              title="回答済み"
              count={question.allAnswerCount || 0}
              unit="人"
              backgroundColor={BackgroundColorType.ACCENT}
            />
          </div>
          <div className={styles.counter}>
            <Counter
              title="残り時間"
              count={timeLimit}
              unit="秒"
              backgroundColor={BackgroundColorType.BASE}
              isTimeup={isTimeup}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default compose<QuestionProps, QuestionProps>(pure)(Question)
